import ActiveDraggableBlockMixin from "../../../mixins/ActiveDraggableBlockMixin";
import ActiveDropzoneMixin from "../../../mixins/ActiveDropzoneMixin";
import EditorEventMixin from "../../../mixins/EditorEventMixin";

Vue.asyncComponent('bp-preview', {
    mixins: [ActiveDraggableBlockMixin, ActiveDropzoneMixin, EditorEventMixin],
    data() {
        return {
            previewIframe: null,
            loading: true,
        }
    },
    props: {
        blocksToRender: {
            type: Array,
            required: true,
        },
        blocks: {
            type: Array,
            required: true,
        },
        breakpoints: {
            type: Array,
            required: true,
        },
        breakpoint: {
            type: Object,
            required: true,
        },
        dataProvider: {
            type: Object,
            required: true,
        },
        forceGuides: {
            type: Boolean,
            required: false,
            default: false
        },
        grid: {
            type: Object,
            required: true,
        },
        activeBreakpointId: {
            type: String,
            required: true,
        }
    },
    computed: {
        previewUrl() {
            return this.dataProvider.getPreviewHandler().getPreviewUrl(this.$route.query.verticalId, this.$route.params.blueprintId)
        },
        /**
         * The current origin of our preview iframe
         * @returns {string}
         */
        iframeOrigin(){
            return (new URL(this.$refs.iframe.src)).origin;
        },
    },
    methods: {
        async renderNewPreview() {

            const data = {
                previewUrl: this.previewUrl,
                settings: {
                    title: this.dataProvider.title,
                    metadata: this.dataProvider.metadataHandler.getMetadata(),
                    headers: this.dataProvider.headerHandler.getHeaders(),
                    breakpoints: this.breakpoints,
                    blocks: this.blocks
                }
            }

            this.$refs.iframe.contentWindow.postMessage(data, this.iframeOrigin);
        },
        /**
         * The child iframe can also send us messages
         * for now we only use this to manipulate the loading state
         * @param event
         */
        childIframeListener(event) {
            if (event.origin !== this.iframeOrigin) {
                return;
            }

            if(event.data && event.data.loading !== undefined) {
                this.loading = event.data.loading;
            }
        },
    },
    mounted() {
        this.loading = true;
        this.previewIframe = this.$refs.iframe;

        this.$refs.iframe.addEventListener('load', this.renderNewPreview);
        window.addEventListener('message', this.childIframeListener,false);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.childIframeListener,false);
        this.$refs.iframe.removeEventListener('load', this.renderNewPreview,false);
    }
}, 'blueprints/editor/preview/bp-preview.html');